import React from "react";
import ContactAddress from "../../components/contact-address";
const ContactPageContainer = () => {
    return (
        <section className="contact-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12" data-aos="fade-up" data-aos-duration="1200">
                        <ContactAddress />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactPageContainer;
